import * as React from 'react';
import { getIsTimedPlus } from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemCardComponent, ItemCardInfo } from '@/components/GridItemCard/types/types';
import { useAppSelector } from '@/redux/hooks';
import MyItemsUpcomingItemCard from '@/components/GridItemCard/Card/CardOptions/MyItemsItemCards/MyItemsUpcomingItemCard';
import TimedPlusMyItemsCard from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/TimedPlusMyItemsCard';

const TimedOrMyItemsItemCard: ItemCardComponent = (props) => {
    const isTimedPlus = useAppSelector((state) => getIsTimedPlus(state, props.itemId));

    const Component = isTimedPlus ? TimedPlusMyItemsCard.ItemCardComponent : MyItemsUpcomingItemCard.ItemCardComponent;

    return <Component {...props} />;
};

const info: ItemCardInfo = { ItemCardComponent: TimedOrMyItemsItemCard };

export default info;
